import React from 'react';
import Icon from 'components/Common/Icons/Icon/Icon';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IconChevronRight = ({ className }: Props) => (
  <Icon className={className}>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 20.2426L18.2426 16L14 11.7573" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </Icon>
);

export default IconChevronRight;
